import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./assets/theme";
import LandingPage from "./components/LandingPage";
import LiteratureReviewGenerator from "./components/LiteratureReviewGenerator";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Box } from "@mui/material";
import TnC from "./components/TnC";

const App = () => {
  const location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Navbar />
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/generator" element={<LiteratureReviewGenerator />} />
            <Route path="/tnc" element={<TnC />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;
